module.exports = __webpack_public_path__ + "static/media/symbols.757e3505.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/doctype-sprite/svg/symbols.svg
// module id = 471
// module chunks = 0